// extracted by mini-css-extract-plugin
module.exports = {"content":"qa-dashboard-content__1jSJa","table":"qa-dashboard-table__hQ1WG"};